import Image from 'next/image'

import { LOGO_TEST_IDS } from '@common/common-test-ids.const'

import appLogoIcon from '../../assets/svg/logo-icon.svg'
import appLogoLabel from '../../assets/svg/logo-label.svg'
import { AlphaLabel } from '../AlphaLabel'

import type { Props } from './Logo.types'

import styles from './Logo.module.scss'

export function Logo({ width, height, hideLabel = false, showAlpha = false }: Props) {
  return (
    <div className={styles.wrapper} data-testid={LOGO_TEST_IDS.root}>
      {!hideLabel ? (
        <div className={styles.logoWithLabel}>
          <Image
            src={appLogoLabel}
            alt="App Logo"
            width={width ?? 135}
            height={height ?? 32}
            priority
            loading="eager"
          />
          {showAlpha && <AlphaLabel withTooltip />}
        </div>
      ) : (
        <Image src={appLogoIcon} alt="App Logo" width={width ?? 32} height={height ?? 32} priority loading="eager" />
      )}
    </div>
  )
}
